import { __assign } from "tslib";
import { hasIntl } from "../../utils/FeatureDetect";
/**
 * Money
 * Realy simple Money implementation which should be
 * extended
 */
var Money = /** @class */ (function () {
    function Money(amount, currency) {
        this.amount = amount;
        this.currency = currency;
    }
    /**
     * Operation methods
     */
    Money.prototype.add = function (money) {
        return new Money(this.amount + money.getAmount(), this.currency);
    };
    Money.prototype.subtract = function (money) {
        return new Money(this.amount - money.getAmount(), this.currency);
    };
    Money.prototype.multiply = function (money) {
        return new Money(this.amount * money.getAmount(), this.currency);
    };
    Money.prototype.divide = function (money) {
        return new Money(this.amount / money.getAmount(), this.currency);
    };
    /**
     * Public methods
     */
    Money.prototype.getAmount = function () {
        return this.amount;
    };
    Money.prototype.getCurrency = function () {
        return this.currency;
    };
    Money.prototype.equalsTo = function (money) {
        return this.currency === money.getCurrency() && this.getAmount() === money.getAmount();
    };
    Money.prototype.format = function (locale, options) {
        return hasIntl()
            ? new Intl.NumberFormat(locale || undefined, __assign({ style: "currency", currency: this.currency }, (options || {}))).format(this.amount * 100)
            : this.currency + " " + this.amount * 100;
    };
    Money.prototype.toString = function () {
        return this.format();
    };
    return Money;
}());
export default Money;
//# sourceMappingURL=Money.js.map